

import { createAsyncThunk } from "@reduxjs/toolkit";
import { getWithAuth } from "../../http";
import { AppThunkAPIType } from "../../app/appTypes";

export type DocView = "recent" | "progress" | "waiting";

export type DocumentWidgetItem = {
    id: number;
    companyId: number;
    number: string;
    title: string;
    status: string;
    type: string;
    kind: string;
    lastOpenedAt?: string | null;
};

export type MyDocumentsWidget = {
    recent: DocumentWidgetItem[];
    inProgress: DocumentWidgetItem[];
    waiting: DocumentWidgetItem[];
};

export const loadMyDocuments = createAsyncThunk<
    MyDocumentsWidget,
    void,
    AppThunkAPIType
>(
    "documents/myDocumentsWidget",
    async (_, { dispatch, rejectWithValue }) => {
        const result = await dispatch(
            getWithAuth({
                url: `api/my-documents`,
            })
        );

        const { payload } = result;

        if (getWithAuth.fulfilled.match(result)) {
            return payload as MyDocumentsWidget;
        }

        return rejectWithValue(payload ?? { kind: "unknown" });
    }
);